// MC20-18329: installConsoleGuard MUST be the first executable statement so
// it wraps console.* before any other module's boot-time logs fire. Do not
// reorder these two lines; do not move imports above them.
import { installConsoleGuard } from '@taleemabad/shared';

import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { AppProvider } from './providers/app-provider';
import { RouterProvider } from 'react-router-dom';
import appRouter from './routes';
import {
  analyticsDB,
  capacitorService,
  deepLinkService,
  preloadPdfWorker,
  resetDB,
} from '@taleemabad/db';
import { CapacitorUpdater } from '@capgo/capacitor-updater';
installConsoleGuard();
deepLinkService.initDeepLinks();
preloadPdfWorker();
CapacitorUpdater.notifyAppReady();
capacitorService.capacitorLiveUpdate();
capacitorService.installApplicationOnLoad();

// MC20-18126: Trim analytics events older than 30 days on every cold start
// so the table can't grow unbounded (~1 MB/month otherwise). Synced events
// only — anything still queued for upload is preserved. Fire-and-forget;
// failures here must not block app boot.
analyticsDB.pruneOldEvents().catch((err) => {
  console.error('analyticsDB.pruneOldEvents failed', err);
});

window.addEventListener('unhandledrejection', async (event) => {
  const error = event.reason;
  if (
    error?.name === 'DatabaseClosedError' &&
    error?.message?.includes('UpgradeError')
  ) {
    try {
      await resetDB();
      window.location.href = '/login';
    } catch (e) {
      console.error('Failed to recover from indexedDB upgrade error', e);
    }
  }
});
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <StrictMode>
    <AppProvider>
      <RouterProvider router={appRouter} />
    </AppProvider>
  </StrictMode>,
);
